<template>
  <div class="banner-slider">
    <slot></slot>
    <div class="img"
      :class="{'active': $i === active}"
      v-for="(img, $i) in images"
      :key="$i"
      :style="'background-image: url('+img.src+'); background-position: center '+img.position">
      <div class="flotante">
        <h2 class="titulo">{{ img.text }}</h2>
        <a href="#"
          class="btn white fw7 f4 pt2 pb2 no-underline"
          @click.prevent="$emit('modal')">
            Conocenos
        </a>
       </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash';

export default {
  data() {
    return {
      images: [],
      active: 0,
      interval: undefined,
    };
  },
  mounted() {
    this.images = _.map(this.$el.querySelectorAll('img'), (el) => {
      const src = el.getAttribute('src');
      const position = el.getAttribute('data-position') || 'center';
      const text = el.getAttribute('data-text') || 'La excelencia en frutas';
      // const bgColor = el.getAttribute('data-bg') || '#fff';
      return { src, position, text };
    });
    this.interval = setInterval(() => {
      if (this.active < this.images.length - 1) {
        this.active += 1;
      } else { this.active = 0; }
    }, 4000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
div.banner-slider {
  width: 100%;
  height: 80vh;
  overflow: hidden;
  position: relative;
  img { display: none }
  div.img {
    background-size: cover;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: opacity 1s;
    &.active {
      opacity: 1;
    }
    .flotante {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        position: absolute;
        z-index: 2;
        color: #fff;
        top: 8%;
        left: 5%;


        .titulo {
          text-overflow: wrap;
          font-size: 2.2em;
          margin: 0;
          margin-bottom: 10px;
          text-align: start;
          width: 50%;
          height: 150px;
        }

        .btn {
          border: 2px solid #fff;
          width: 15vw;
          border-radius: 10px;
          float: left;
          p {
            display: block;
            margin: 12px ;
            font-weight: bold;
            font-size: 1.2rem;
            transition: all ease .5s;
          }
        }
      }
  }
}

@media screen and (max-width: 700px) {
  div.banner-slider div.img .flotante {
    width: 100%;
    top: 6%;
    a.btn {
      width: 50%;
    }
  }
}

</style>
